module.exports = {"AT":"AUSTRIA","AU":"AUSTRALIA","BE":"BELGIUM","BR":"BRAZIL","CA":"CANADA","CH":"SWITZERLAND","CL":"CHILE","CZ":"CZECH REPUBLIC","DE":"GERMANY","DK":"DENMARK","EE":"ESTONIA","ES":"SPAIN","FI":"FINLAND","FR":"FRANCE","GB":"UNITED KINGDOM","GR":"GREECE","HU":"HUNGARY","IE":"IRELAND","IL":"ISRAEL","IS":"ICELAND","IT":"ITALY","JP":"JAPAN","KR":"SOUTH KOREA","LU":"LUXEMBOURG","LV":"LATVIA","MX":"MEXICO","NL":"NETHERLANDS","NO":"NORWAY","NZ":"NEW ZEALAND","PL":"POLAND","PT":"PORTUGAL","RU":"RUSSIA","SE":"SWEDEN","SI":"SLOVENIA","SK":"SLOVAKIA","TR":"TURKEY","US":"USA","ZA":"SOUTH AFRICA"}


//////////////////
// WEBPACK FOOTER
// ./src/data/CountryNames.json
// module id = 135
// module chunks = 0